/* eslint-disable camelcase */
import '@sass/lastminute/lastminute.scss';
import '@module/LinkBox/LinkBox.js';
import { bindIntersectionObserver, debounce, documentReady, fadeIn, fadeOut, gebi, isDesktopView, isMobileView, isVisible, lLink, logEvent, qs, qsa, setUrlParameter } from '@utils/toolbox';
import { eventCategories, events } from '@js/utils/event';
import { ConnectApi } from '@js/plugins/connectApi';
import { resultsRender } from '@js/components/resultsRender';

const lastminute = {
	elems: {},
	request: false,
	currentSearchParams: {},
	scrollLastPosition: 0,
	scrollPosition: 0,
	scrollTimer: 0,
	listPage: false,
	initIntersectionObserver () {
		bindIntersectionObserver(qs('[data-intersection-observer]'), (entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					lastminute.infiniteScroll();
				}
			});
		}, { root: null, rootMargin: '30%', threshold: 0.1 });
	},
	init () {
		lastminute.elems.ListContainer = qs('#lastminute-list-container');
		lastminute.elems.ListLoader = qs('#lastminute-list-loader');
		lastminute.elems.ListHeader = qs('#list-view-header');
		lastminute.elems.ListView = qs('#lastminute-list-view');
		lastminute.elems.destinationCities = qsa('#multi-select-to .multi-select__list-item--children .multi-select__checkbox');
		lastminute.elems.destinationCountries = qsa('#multi-select-to .multi-select__list-item--parent');

		// Copy initial last minute params (on landing pages)
		if (typeof js_params.lastminuteParams !== 'undefined') {
			lastminute.currentSearchParams = js_params.lastminuteParams;
		}

		// Copy initial last minute params (on landing pages)
		if (typeof js_params.lastminuteScrollToList !== 'undefined') {
			window.scrollTo({ top: lastminute.elems.ListView.offsetTop });
		}

		this.generateFieldText();

		this.initIntersectionObserver();

		resultsRender.init();

		// Click events
		document.body.addEventListener('click', async (event) => {
			if (event.target.closest('.resultCard__ota')) {
				logEvent(events.clickoutResultList, eventCategories.clickout);
				return;
			}

			if (event.target.closest('.modal--resultModal .otaLink')) {
				logEvent(events.clickoutResultModal, eventCategories.clickout);
				return;
			}

			if (event.target.closest('.resultCard.resultCard--lastminute')) {
				// Show the loader if the network request takes more than 300ms
				const loaderTimeout = setTimeout(() => {
					fadeIn(lastminute.elems.ListLoader, 200);
				}, 300);

				const element = event.target.closest('.resultCard.resultCard--lastminute');
				const orgIndex = element.dataset.orgIndex;

				// Extract the response id from the url parameter
				const responseId = element.dataset.responseId;

				try {
					// Get the flight data from the backend
					const response = await ConnectApi('Lastminute', 'getFlightByHash', [responseId, orgIndex]);

					// If the request finishes before 300ms, clear the timeout and hide the loader
					clearTimeout(loaderTimeout);
					fadeOut(lastminute.elems.ListLoader, 180);

					// Render the modal
					resultsRender.setData(response);
					const flight = resultsRender.response.flights[0];
					resultsRender.renderModal(responseId, flight, 0, {}, { className: 'modal--resultModal' }, {}, 'lastminute').open();

					logEvent(events.viewmoreResult, eventCategories.viewmore);
				} catch (error) {
					// Handle any errors
					clearTimeout(loaderTimeout);
					fadeOut(lastminute.elems.ListLoader, 180);
					console.error('Error fetching flight data:', error);
				}

				return;
			}


			// Open filter dropdown
			if (event.target.closest('.abInputWrapper')) {
				qsa('.abInputWrapper').forEach(inputWrapper => inputWrapper.classList.remove('active'));
				event.target.closest('.abInputWrapper').classList.add('active');

				this.showOverlay();
			}

			// Close filter for mobile
			if (event.target.closest('.multi-select-close-filters')) {
				this.hideOverlay();
			}

			// Clear text input filtering destinations
			if (event.target.closest('[data-action="clear-filter-destinations"]')) {
				gebi('filter-destinations').value = '';
				this.filterCity();
			}

			// Clicking on a sorting column resets the list and calls to update url and list
			if (event.target.closest('.abTabNav__btn:not(.disabled)')) {
				if (!isVisible(event.target.closest('.abTabNav__btn'))) {
					return false;
				}

				lastminute.resetListPage();
				lastminute.setSorting(event.target.closest('.abTabNav__btn').dataset.sorting);
				event.preventDefault();
			}

			// Close filter for desktop
			if (!event.target.closest('.abInputWrapper.active')) {
				if (isDesktopView()) {
					if (qsa('.abInputWrapper.active').length) {
						qsa('.abInputWrapper.active').forEach(inputWrapper => inputWrapper.classList.remove('active'));
					}
				}

				this.hideOverlay();
			}
		});

		// Text input to filter destinations
		qs('#filter-destinations').addEventListener('keyup', (event) => {
			debounce(this.filterCity(event.target.value), 500);
		});
		// Changes in form to change results
		qsa('.multi-select__scroller').forEach(element => element.addEventListener('change', (event) => {
			// Parent checkbox change children
			if (event.target.closest('.multi-select__list-item--parent > label > input[type="checkbox"]')) {
				const change = event.target.closest('.multi-select__list-item--parent > label > input[type="checkbox"]').checked;
				const papi = event.target.closest('.multi-select__list-item--parent');

				papi.querySelectorAll('.multi-select__list-item--children input[type="checkbox"]').forEach((checkbox) => {
					checkbox.checked = change;
				});
			// Toggle all children toggle parent
			} else if (event.target.closest('.multi-select__list-item--parent input[type="checkbox"]')) {
				const papi = event.target.closest('.multi-select__list-item--parent');

				const checkboxes = papi.querySelectorAll('.multi-select__list-item--children input[type="checkbox"]');
				const activeCheckboxes = papi.querySelectorAll('.multi-select__list-item--children input[type="checkbox"]:checked');
				papi.querySelector('input[type="checkbox"]').checked = checkboxes.length === activeCheckboxes.length;
			// Toggle parent checkbox toggle all children
			} else if (event.target.closest('.multi-select__list-item--toggle-all > label > input[type="checkbox"]')) {
				const change = event.target.closest('.multi-select__list-item--toggle-all > label > input[type="checkbox"]').checked;
				const papi = event.target.closest('.multi-select__dropdown');

				papi.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
					checkbox.checked = change;
				});
			}

			this.generateFieldText();
			this.refineSearch(event);
		}));
	},
	hideOverlay () {
		if (isMobileView()) {
			if (qs('.abInputWrapper.active')) {
				qs('.abInputWrapper.active').classList.remove('active');
				document.body.classList.remove('fixed');
				gebi('overlay').classList.remove('display');
			}
		}
	},
	showOverlay () {
		if (isMobileView()) {
			document.body.classList.add('fixed');
			gebi('overlay').classList.add('display');
		}
	},
	generateFieldText () {
		qsa('.list-view-header .abInputWrapper').forEach((wrapper) => {
			let newTitle = '';
			wrapper.querySelectorAll('.multi-select__list-item--children input[type="checkbox"]').forEach((child) => {
				if (child.checked) {
					newTitle += child.value + ', ';
				}
			});

			if (newTitle && !wrapper.querySelector('.multi-select__list-item--toggle-all input[type="checkbox"]').checked) {
				wrapper.querySelector('.abInputMulti__btn--text').innerHTML = newTitle.substring(0, newTitle.length - 2);
			} else {
				wrapper.querySelector('.abInputMulti__btn--text').innerHTML = wrapper.querySelector('.abInputMulti__btn--text').dataset.default;
			}
		});
	},
	filterCity (filterString = '') {
		/**
		 * Hide children with a value that doesnt match the search
		 * Check if parent should be hidden, and if all children are hidden, hide
		 */
		filterString = filterString.charAt(0).toUpperCase() + filterString.slice(1);
		if (filterString.length > 1) {
			lastminute.elems.destinationCountries.forEach((countryEl) => {
				let hideParty = true;
				const cities = countryEl.querySelectorAll('.multi-select__list-item--children .checkbox');

				cities.forEach((cityEl) => {
					if (cityEl.dataset?.value?.includes(filterString)) {
						cityEl.classList.remove('hide');
						hideParty = false;
					} else {
						cityEl.classList.add('hide');
					}
				});

				if (countryEl.dataset?.value?.includes(filterString)) {
					countryEl.classList.remove('hide');
				} else {
					if (hideParty) {
						countryEl.classList.add('hide');
					} else {
						countryEl.classList.remove('hide');
					}
				}
			});
		} else {
			lastminute.elems.destinationCities.forEach(cityEl => cityEl.classList.remove('hide'));
			lastminute.elems.destinationCountries.forEach(countryEl => countryEl.classList.remove('hide'));
		}
	},
	refineSearch (event) {
		event && event.preventDefault();

		lastminute.resetListPage();

		const selected = lastminute.getFilters();
		let url = lastminute.setFiltering(selected);
		const postData = selected;

		if (typeof js_params.lastminuteParams.sort !== 'undefined') {
			postData.sort = js_params.lastminuteParams.sort;

			url = setUrlParameter(url, 'sort', postData.sort);
		}

		window.history.replaceState({}, '', url);

		lastminute.searchLastminute(postData, []);

		if (js_params.device === 'MOBILE') {
			window.scrollTo({ top: lastminute.elems.ListView.offsetTop });
		}
	},
	infiniteScroll () {
		if (lastminute.elems.ListContainer.querySelectorAll('.lastminute-list-row-noresults').length > 0) {
			return false;
		}

		lastminute.searchLastminute(lastminute.currentSearchParams, {
			SkipSortingHtml: true,
			NextPage: true
		});
	},
	resetListPage () {
		lastminute.listPage = false;
		lastminute.scrollLastPosition = 0;
		lastminute.scrollPosition = 0;

		if (typeof lastminute.currentSearchParams.page !== 'undefined') {
			delete lastminute.currentSearchParams.page;
		}
	},
	incrementListPage (add) {
		if (!lastminute.listPage) {
			lastminute.listPage = 1;
		} else {
			lastminute.listPage += add;
		}

		return lastminute.listPage;
	},

	// Get all selected filters from filter box, group them by filter category (from, to, leave, length)
	getFilters () {
		const selected = {
			from: qsa('#multi-select-from .multi-select__list-item--children input[type="checkbox"]:checked').map(element => element.dataset.param),
			to: qsa('#multi-select-to .multi-select__list-item--children input[type="checkbox"]:checked').map(element => element.dataset.param.split(',')).flat(),
			leave: qsa('#multi-select-leave .multi-select__list-item--children input[type="checkbox"]:checked').map(element => element.dataset.param),
			triplength: qsa('#multi-select-triplength .multi-select__list-item--children input[type="checkbox"]:checked').map(element => element.dataset.param),
			adults: qsa('#multi-select-adults .multi-select__list-item--children input[type="checkbox"]:checked').map(element => element.dataset.param)
		};

		// Delete empty values
		Object.keys(selected).forEach(key => selected[key].length === 0 && delete selected[key]);

		return selected;
	},

	// Update the url with the selected filters
	setFiltering (selected) {
		let url = window.location.origin + '/' + lLink('global.navigation.lastMinuteLink') + window.location.search;

		url = url.split(/[?#]/)[0];

		if (Object.keys(selected).length) {
			let urlParams = '';

			Object.entries(selected).forEach(function ([i, v]) {
				urlParams = (Array.isArray(v)) ? v.join(',') : v;
				url = setUrlParameter(url, i, urlParams);
			});
		}

		return url;
	},

	// Update the url with selected sorting, initiate new search with active filters and sorting
	setSorting (sortname) {
		const selected = lastminute.getFilters();
		let url = lastminute.setFiltering(selected);

		const params = lastminute.currentSearchParams;
		const srt = sortname;

		qsa('.abTabNav--lastMinuteSortingColumns .active').forEach(function (element) {
			element.classList.remove('active');
		});

		lastminute.elems.ListHeader.querySelector('.abTabNav__btn[data-sorting="' + sortname + '"]').classList.add('active');

		params.sort = srt;

		url = setUrlParameter(url, 'sort', params.sort);

		window.history.replaceState({}, '', url);

		lastminute.searchLastminute(params, {
			SkipSortingHtml: true
		});

		lastminute.elems.ListHeader.querySelector('.abTabNav__btn.active').classList.remove('active');
		lastminute.elems.ListHeader.querySelector('.abTabNav__btn[data-sorting="' + sortname + '"]').classList.add('active');
	},

	// Start a new search
	searchLastminute (params, options) {
		params = (typeof params !== 'undefined') ? params : [];
		options = (typeof options !== 'undefined') ? options : [];
		if (!isVisible(lastminute.elems.ListLoader)) {
			fadeIn(lastminute.elems.ListLoader, 400);
		}

		lastminute.getResults(params, options);
	},

	// Connect to the module with selected params and request a new list
	getResults (params, options) {
		if (lastminute.request) {
			lastminute.request.abort();
			params.page = lastminute.incrementListPage(-1);
		}

		if (options.NextPage) {
			params.page = lastminute.incrementListPage(1);
		}

		lastminute.request = ConnectApi('Lastminute', 'getData', [{ params, options }])
			.then((response) => {
				if (!lastminute.elems.ListContainer.hasChildNodes() || !lastminute.listPage) {
					lastminute.elems.ListContainer.innerHTML = response.rowsHtml;
				} else {
					lastminute.elems.ListContainer.insertAdjacentHTML('beforeend', response.rowsHtml);
				}

				if (response.discount && response.discount != 0) {
					qs('.abTabNav__btn.discount .abTabNav__deal').innerHTML = `-${response.discount}%`;
					qs('.abTabNav__btn.discount').classList.remove('disabled');
				} else {
					qs('.abTabNav__btn.discount').classList.add('disabled');
				}
				qs('.abTabNav__btn.best .abTabNav__deal').innerHTML = response.cheapest;

				lastminute.currentSearchParams = params;
			})
			.finally(() => {
				fadeOut(lastminute.elems.ListLoader, 180);
				lastminute.request = false;
			});
		return lastminute.request;
	}
};

documentReady(function () {
	window.lastminute = lastminute;
	lastminute.init();
});
